import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import Paper from "@material-ui/core/Paper";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import Toolbar from "@material-ui/core/Toolbar";
import * as Utils from "../Utils";
import * as Config from "./utils/ConfigurationRegistry";
import Header from "../header/Header";
import Navigator from "./Navigator";
import { useConfigProfile } from "./profile/ConfigurationProfile";
import ErrorMessageDialog from "./dialog/ErrorMessageDialog";
var defaultNavigationPanelWidth = 270;
var styles = function styles(theme) {
  var _paper, _main;
  return {
    paper: (_paper = {}, _defineProperty(_paper, theme.breakpoints.down("xs"), {
      width: "100%",
      marginBottom: theme.spacing(2),
      padding: theme.spacing(1)
    }), _defineProperty(_paper, theme.breakpoints.up("sm"), {
      width: "100%",
      marginBottom: theme.spacing(2),
      padding: theme.spacing(3)
    }), _paper),
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#00A994",
      backgroundColor: "#eaeff1"
    },
    root: {
      display: "flex",
      minHeight: "100vh"
    },
    app: {
      flex: 1,
      display: "flex",
      flexDirection: "column"
    },
    main: (_main = {}, _defineProperty(_main, theme.breakpoints.down("xs"), {
      flex: 1,
      padding: theme.spacing(2, 1),
      background: "#eaeff1"
    }), _defineProperty(_main, theme.breakpoints.up("sm"), {
      flex: 1,
      padding: theme.spacing(2, 2),
      background: "#eaeff1"
    }), _main),
    footer: {
      padding: theme.spacing(2),
      background: "#eaeff1"
    }
  };
};
function ConfigurationDashboard(_ref) {
  var classes = _ref.classes,
    navigation = _ref.navigation,
    welcomeContent = _ref.welcomeContent,
    headerButtons = _ref.headerButtons,
    actionButtons = _ref.actionButtons,
    navigationPanelWidth = _ref.navigationPanelWidth,
    resetNavigation = _ref.resetNavigation,
    controlledNavigationIndex = _ref.navigationIndex,
    controlledSubNavigationIndex = _ref.subNavigationIndex,
    handleNavigationChange = _ref.handleNavigationChange;
  console.log("Configuration dashboard");
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mobileOpen = _React$useState2[0],
    setMobileOpen = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    initializationStatus = _React$useState4[0],
    setInitializationStatus = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    errorMessage = _React$useState6[0],
    setErrorMessage = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    previousContentItem = _React$useState8[0],
    setPreviousContentItem = _React$useState8[1];
  var _React$useState9 = React.useState(controlledNavigationIndex),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    navigationIndex = _React$useState10[0],
    setNavigationIndex = _React$useState10[1];
  var _React$useState11 = React.useState(controlledSubNavigationIndex),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    subNavigationIndex = _React$useState12[0],
    setSubNavigationIndex = _React$useState12[1];
  var _useConfigProfile = useConfigProfile(),
    _useConfigProfile2 = _slicedToArray(_useConfigProfile, 2),
    profile = _useConfigProfile2[0],
    setProfile = _useConfigProfile2[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    expandedNavigations = _React$useState14[0],
    setExpandedNavigations = _React$useState14[1];
  React.useEffect(function () {
    if (handleNavigationChange) {
      handleNavigationChange(navigationIndex, subNavigationIndex);
    }
  }, [navigationIndex, subNavigationIndex]);
  React.useEffect(function () {
    setNavigationIndex(controlledNavigationIndex);
    setSubNavigationIndex(controlledSubNavigationIndex);
  }, [controlledNavigationIndex, controlledSubNavigationIndex]);
  React.useEffect(function () {
    if (resetNavigation !== undefined) {
      setNavigationIndex(null);
      setSubNavigationIndex(null);
      setExpandedNavigations([]);
    }
  }, [resetNavigation]);
  var handleDrawerToggle = function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  };
  var currentNavigationItem = null;
  if (navigationIndex != null) {
    if (subNavigationIndex != null) {
      currentNavigationItem = navigation[navigationIndex].subNavigation[subNavigationIndex];
    } else {
      currentNavigationItem = navigation[navigationIndex];
    }
  }
  var currentContentItem = (currentNavigationItem == null ? welcomeContent : currentNavigationItem).component;
  var handleNavigationClick = function handleNavigationClick(navigationContent, index, subIndex) {
    setNavigationIndex(index);
    setSubNavigationIndex(subIndex);
    setPreviousContentItem(currentContentItem);
    setMobileOpen(false);
  };
  useEffect(function () {
    if (profile && profile.doNotReloadConfigurationValues) {
      setInitializationStatus("success");
      return;
    }
    setInitializationStatus("loading");
    Utils.fetchData("configuration/values" + (profile && profile.name ? "?profile=" + profile.name : "")).then(function (data) {
      Config.setConfigurationValues(data.values, data.defaults);
      setInitializationStatus("success");
    }).catch(function (response) {
      setInitializationStatus("error");
      Utils.getErrorMessage(response, "Internal Server Error.").then(setErrorMessage);
    });
  }, [profile]);
  var drawerWidth = navigationPanelWidth ? navigationPanelWidth : defaultNavigationPanelWidth;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Backdrop, {
    className: classes.backdrop,
    open: !initializationStatus || initializationStatus === "loading"
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    color: "inherit"
  })), /*#__PURE__*/React.createElement(Header, {
    topButtons: headerButtons,
    bottomButtons: actionButtons,
    onDrawerToggle: handleDrawerToggle,
    hideListIcon: !Boolean(navigation)
  }), initializationStatus === "error" && /*#__PURE__*/React.createElement(ErrorMessageDialog, {
    description: errorMessage,
    open: true
  }), initializationStatus === "success" && /*#__PURE__*/React.createElement(React.Fragment, null, navigation && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Hidden, {
    smUp: true,
    implementation: "js"
  }, /*#__PURE__*/React.createElement("nav", {
    elevation: 10
  }, /*#__PURE__*/React.createElement(Navigator, {
    PaperProps: {
      style: {
        width: drawerWidth
      }
    },
    handleNavigationClick: handleNavigationClick,
    variant: "temporary",
    open: mobileOpen,
    navigation: navigation,
    activeListItem: currentNavigationItem,
    onClose: handleDrawerToggle,
    expandedNavigations: expandedNavigations,
    setExpandedNavigations: setExpandedNavigations
  }))), /*#__PURE__*/React.createElement(Hidden, {
    xsDown: true,
    implementation: "css"
  }, /*#__PURE__*/React.createElement("nav", {
    style: {
      width: drawerWidth,
      flexShrink: 0
    },
    elevation: 10
  }, /*#__PURE__*/React.createElement(Navigator, {
    handleNavigationClick: handleNavigationClick,
    navigation: navigation,
    activeListItem: currentNavigationItem,
    PaperProps: {
      style: {
        width: drawerWidth
      }
    },
    expandedNavigations: expandedNavigations,
    setExpandedNavigations: setExpandedNavigations
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.app
  }, /*#__PURE__*/React.createElement(Fade, {
    timeout: 100,
    in: !previousContentItem,
    onExited: function onExited() {
      setPreviousContentItem(null);
    }
  }, /*#__PURE__*/React.createElement("main", {
    className: classes.main
  }, /*#__PURE__*/React.createElement(Toolbar, null), /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, previousContentItem || currentContentItem || /*#__PURE__*/React.createElement("div", null)))))));
}
export default withStyles(styles)(ConfigurationDashboard);